export const LINK_RELATIONSHIPS = [
  'Spouse',
  'Partner',
  'Parent',
  'Child',
  'Household Member',
  'Caregiver',
  'Other',
];

export const FAMILY_RELATIONSHIPS = ['Spouse', 'Partner', 'Parent', 'Child'];

export interface LinkedJobRow {
  orderId?: string;
  invoiceNumber?: string;
  patientId?: string;
  patientName?: string;
  status?: string;
  ready?: boolean;
  dateAdded?: string | Date;
  balanceDue?: number;
}

export interface LinkSummary {
  notifyPreference?: string;
  patientJobCount?: number;
  patientJobIndex?: number;
  patientReadyCount?: number;
  groupKind?: 'FAMILY' | 'HOUSEHOLD' | 'LINKED' | string | null;
  groupJobCount?: number;
  groupJobIndex?: number;
  groupReadyCount?: number;
  jobs?: LinkedJobRow[];
}

export function inverseRelationship(relationship: string): string {
  if (relationship === 'Parent') {
    return 'Child';
  }
  if (relationship === 'Child') {
    return 'Parent';
  }
  return relationship;
}

export function relationshipKind(relationship: string): 'FAMILY' | 'HOUSEHOLD' | 'LINKED' {
  if (FAMILY_RELATIONSHIPS.indexOf(relationship) !== -1) {
    return 'FAMILY';
  }
  if (relationship === 'Household Member') {
    return 'HOUSEHOLD';
  }
  return 'LINKED';
}

export function groupIcon(kind?: string | null): string {
  if (kind === 'FAMILY') {
    return 'groups';
  }
  if (kind === 'HOUSEHOLD') {
    return 'home';
  }
  return 'link';
}

export function groupPositionLabel(kind: string, index: number, total: number): string {
  if (kind === 'FAMILY') {
    return `FAMILY JOB ${index} OF ${total}`;
  }
  if (kind === 'HOUSEHOLD') {
    return `HOUSEHOLD JOB ${index} OF ${total}`;
  }
  return `LINKED JOB ${index} OF ${total}`;
}

export function groupReadyLabel(kind: string, ready: number, total: number): string {
  if (kind === 'FAMILY') {
    return `FAMILY JOBS · ${ready} OF ${total} READY`;
  }
  if (kind === 'HOUSEHOLD') {
    return `HOUSEHOLD JOBS · ${ready} OF ${total} READY`;
  }
  return `LINKED JOBS · ${ready} OF ${total} READY`;
}

export function notifyPreferenceLabel(preference?: string): string {
  return String(preference || '').toUpperCase() === 'WAIT_ALL'
    ? 'WAIT FOR ALL'
    : 'NOTIFY EACH';
}
